<script>
export default {
  data() {
    return {
      walletData : [
        {
          title: "Resumo Mensal",
          text: "Valor acumulado",
          amount: "R$ 6.800.134,39",
          subamount: "+ 0.0012.23 ( 0.2 % )",
          income: "R$ 2.640.632,46",
          expense: "R$ 3.460,38",
          chartSeries: [76, 67, 61],
          balancelist: [
            {
              text: "Grupo Testes 001",
              coin: "4.570 kg",
              amount: "R$ 1.700,12",
            },
            {
              text: "Grupo Testes 002",
              coin: "441 Kg",
              amount: "R$ 4.025,32",
            },
            {
              text: "Grupo Testes 999",
              coin: "353 Kg",
              amount: "R$ 2.263,09",
            },
          ],
        },
      ],
      chartOptions: {
        chart: {
          height: 300,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "35%",
              background: "transparent",
              image: undefined,
            },
            track: {
              show: true,
              startAngle: undefined,
              endAngle: undefined,
              background: "#f2f2f2",
              strokeWidth: "97%",
              opacity: 1,
              margin: 12,
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
            dataLabels: {
              name: {
                show: true,
                fontSize: "16px",
                fontWeight: 600,
                offsetY: -10,
              },
              value: {
                show: true,
                fontSize: "14px",
                offsetY: 4,
                formatter: function (val) {
                  return val + "%";
                },
              },
              total: {
                show: true,
                label: "Total",
                color: "#373d3f",
                fontSize: "16px",
                fontFamily: undefined,
                fontWeight: 600,
                formatter: function (w) {
                  return (
                    w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0) + "%"
                  );
                },
              },
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        colors: ["#3452e1", "#f1b44c", "#50a5f1"],
        labels: ["Grupo Testes 999", "Grupo Testes 001", "Grupo Testes 898"],
        legend: {
          show: false,
        },
      },
    };
  },
  methods: {
    onChange(event) {
      switch (event.target.value) {
        case "fevereiro":
          this.walletData = [
            {
              title: "Resumo Mensal",
              text: "Valor acumulado",
              amount: "R$ 2.111,39",
              subamount: "+ 0.0014.23 ( 0.2 % )",
              income: "R$ 2.168,46",
              expense: "R$ 927,38",
              chartSeries: [38, 78, 48],
              balancelist: [
                {
                  text: "Grupo Testes 001",
                  coin: "2.5701 Kg",
                  amount: "R$ 1123.64",
                },
                {
                  text: "Grupo Testes 055",
                  coin: "0.8552 Kg",
                  amount: "R$ 4025.32",
                },
                {
                  text: "Grupo Testes 999",
                  coin: "35.7411 Kg",
                  amount: "R$ 2263.09",
                },
              ],
            },
          ];
          break;

        case "janeiro":
          this.walletData = [
            {
              title: "Resumo Mensal",
              text: "Valor acumulado",
              amount: "R$ 1.211,39",
              subamount: "+ 0.0014.23 ( 0.2 % )",
              income: "R$ 468,46",
              expense: "R$ 127,38",
              chartSeries: [47, 68, 49],
              balancelist: [
                {
                  text: "Grupo Testes 001",
                  coin: "2.570 Kg",
                  amount: "R$ 723,64",
                },
                {
                  text: "Grupo Testes 055",
                  coin: "855 Kg",
                  amount: "R$ 1.225,32",
                },
                {
                  text: "Grupo Testes 999",
                  coin: "741 Kg",
                  amount: "R$ 4.563,09",
                },
              ],
            },
          ];
          break;

        case "dezembro":
          this.walletData = [
            {
              title: "Resumo Mensal",
              text: "Valor acumulado",
              amount: "R$ 1.011,39",
              subamount: "+ 0.0014.23 ( 0.2 % )",
              income: "R$ 668,46",
              expense: "R$ 427,38",
              chartSeries: [36, 58, 78],
              balancelist: [
                {
                  text: "Grupo Testes 001",
                  coin: "2.570 Kg",
                  amount: "R$ 523,64",
                },
                {
                  text: "Grupo Testes 055",
                  coin: "855 Kg",
                  amount: "R$ 1.025,32",
                },
                {
                  text: "Grupo Testes 999",
                  coin: "411 Kg",
                  amount: "R$ 6.563,09",
                },
              ],
            },
          ];
          break;

        case "marco":
          this.walletData = [
            {
              title: "Resumo Mensal",
              text: "Valor acumulado",
              amount: "R$ 2111.39",
              subamount: "+ 0.0014.23 ( 0.2 % )",
              income: "R$ 2168.46",
              expense: "R$ 927.38",
              chartSeries: [38, 78, 48],
              balancelist: [
                {
                  text: "Grupo Testes 001",
                  coin: "2.570 Kg",
                  amount: "R$ 1.123,64",
                },
                {
                  text: "Grupo Testes 055",
                  coin: "802 Kg",
                  amount: "R$ 4.025,32",
                },
                {
                  text: "Grupo Testes 999",
                  coin: "150 Kg",
                  amount: "R$ 2.263,09",
                },
              ],
            },
          ];
          break;
        default:
          this.walletData = [
            {
              title: "Resumo Mensal",
              text: "Valor acumulado",
              amount: "R$ 1.011,39",
              subamount: "+ 0.0014.23 ( 0.2 % )",
              income: "R$ 668,46",
              expense: "R$ 427,38",
              chartSeries: [25, 58, 47],
              balancelist: [
                {
                  text: "Grupo Testes 001",
                  coin: "8.600 Kg",
                  amount: "R$ 523.604,32",
                },
                {
                  text: "Grupo Testes 055",
                  coin: "1.855 Kg",
                  amount: "R$ 102.532,85",
                },
                {
                  text: "Grupo Testes 999",
                  coin: "745 Kg",
                  amount: "R$ 65.098,80",
                },
              ],
            },
          ];
          break;
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="card" v-for="(data, index) of walletData" :key="index">
      <div class="card-body">
        <div class="float-end">
          <select
            id="selectWalletPeriodo"
            class="form-select form-select-sm ms-2"
            @change="onChange($event)"
          >
            <option value="marco" selected>Março</option>
            <option value="fevereiro">Fevereiro</option>
            <option value="janeiro">Janeiro</option>
            <option value="dezembro">Dezembro</option>
          </select>
        </div>
        <h4 class="card-title mb-3">{{ data.title }}</h4>

        <div class="row">
          <div class="col-lg-4">
            <div class="mt-4">
              <p>{{ data.text }}</p>
              <h4>{{ data.amount }}</h4>

              <p class="text-muted mb-4">
                {{ data.subamount }}
                <i class="mdi mdi-arrow-up ms-1 text-success"></i>
              </p>

              <div class="row">
                <div class="col-6">
                  <div>
                    <p class="mb-2">Orçamentos</p>
                    <h5>{{ data.income }}</h5>
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    <p class="mb-2">Pedidos</p>
                    <h5>{{ data.expense }}</h5>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <router-link to="/pedidos/list" href="#" class="btn btn-primary btn-sm"
                  >Mais detalhes <i class="mdi mdi-arrow-right ms-1"></i
                ></router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-sm-6">
            <div>
              <apexchart
                class="apex-charts"
                dir="ltr"
                type="radialBar"
                height="300"
                :series="data.chartSeries"
                :options="chartOptions"
              ></apexchart>
            </div>
          </div>

          <div class="col-lg-4 col-sm-6 align-self-center">
            <div
              v-for="(data, i) of data.balancelist"
              :key="i"
              class="mt-4 pt-2"
            >
              <p class="mb-2">
                <i
                  class="
                    mdi mdi-circle
                    align-middle
                    font-size-10
                    me-2
                    text-primary
                  "
                ></i>
                {{ data.text }}
              </p>
              <h5>
                {{ data.coin }} =
                <span class="text-muted font-size-14">{{ data.amount }}</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
